import * as React from 'react';
export const novoSvg = React.forwardRef(function novoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#3873FF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26 18.305v6.686h-6.67v-6.686a6.64 6.64 0 0 0-1.945-4.706 6.651 6.651 0 0 0-4.715-1.942V25H6v-6.752a6.635 6.635 0 0 1 4.108-6.146 6.736 6.736 0 0 1 2.552-.502V5a13.3 13.3 0 0 1 5.105 1.013 13.23 13.23 0 0 1 4.326 2.889A13.298 13.298 0 0 1 26 18.314v-.01Z',
      fill: '#fff',
    }),
  );
});
novoSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var novo = {
  category: 'brand',
  colorable: false,
  name: 'novo',
  svg: novoSvg,
};
